export { default } from './TaskPanelBodyAsOwner';



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/TaskPanelBodyAsOwner/index.js